export const initAnimationObserver = () => {

    const observedElements = document.querySelectorAll(".animate")

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            let elm = entry.target.querySelector(".animate");
            let animation = elm.dataset.animation;
            if (entry.isIntersecting) {
                elm.classList.add('animated', animation);
            } else {
                elm.classList.remove('animated', animation);
            }
        })
    }

    const options = {
        threshold: 0.4
    }

    const observer = new IntersectionObserver(callback, options)

    observedElements.forEach( element => {
        // We observe the parent element to avoid the animation to be triggered when the element is partially visible
        observer.observe(element.parentNode)
    })
};
